import React, { useContext, useEffect, useRef, useState } from 'react'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import AdminSlotCard from './AdminSlotCard'
import AdminSlotPage from './AdminSlotPage'
import { useNavigate, useParams, useBlocker } from 'react-router-dom'
import { get, post } from '../../Common/api'
import dayjs from 'dayjs'
import { useForm } from 'antd/es/form/Form'
import GlobalContext from '../GlobalContext'
import { Modal } from 'antd'
import { t } from 'i18next'
import consumer from '../../Common/cable'
import _ from 'lodash'

export default function AdminSlot () {
  const { id } = useParams()
  const params = new URLSearchParams(location.search)
  const from = params.get('from')
  const [slot, setSlot] = useState()
  const [loading, setLoading] = useState(false)
  const [newLog, setNewLog] = useState()
  const [isDirty, setIsDirty] = useState(false)
  const isDirtyRef = useRef(isDirty)
  const navigate = useNavigate()
  const [form] = useForm()
  const { notificationApi } = useContext(GlobalContext)

  const blocker = useBlocker(isDirty)

  useEffect(() => {
    isDirtyRef.current = isDirty
  }, [isDirty])

  // Afficher le modal quand la navigation est bloquée
  useEffect(() => {
    if (blocker.state === 'blocked') {
      Modal.confirm({
        title: t('Admin.FeedbackForm.unsavedChangesTitle'),
        content: t('Admin.FeedbackForm.unsavedChangesContent'),
        okText: t('Admin.btn.leave'),
        cancelText: t('Admin.btn.stay'),
        onOk: () => blocker.proceed(),
        onCancel: () => blocker.reset()
      })
    }
  }, [blocker])

  useEffect(() => {
    getSlot()
    // Bloquer le rafraîchissement de page
    const handleBeforeUnload = (e) => {
      if (isDirtyRef.current) {
        e.preventDefault()
        e.returnValue = ''
      }
    }
    const subscription = consumer.subscriptions.create({ channel: 'LogsChannel', slot_id: id }, {
      connected: () => { console.log('connected') },
      disconnected: () => { console.log('disconnected') },
      received: (data) => { setNewLog(data) }
    })
    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => {
      subscription.unsubscribe()
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [consumer, id])

  useEffect(() => {
    if (newLog && slot && dayjs(newLog.created_at).isSame(dayjs(slot.begin_date), 'day')) {
      setSlot({ ...slot, logs: [newLog, ...slot.logs] })
    }
  }, [newLog])

  const screens = useBreakpoint()

  const getSlot = async () => {
    setLoading(true)
    await get({
      url: `admin/slots/${id}`,
      params: {},
      onSuccess: (json) => {
        setSlot({ ...json })
        setLoading(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const cancel = () => {
    setLoading(true)
    post({
      url: `admin/slots/${id}/cancel`,
      params: {},
      notification: { api: notificationApi, state: 'update' },
      onSuccess: (json) => {
        setSlot({ ...slot, ...json })
        setLoading(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const delay = () => {
    setLoading(true)
    post({
      url: `admin/slots/${id}/delay`,
      params: {},
      notification: { api: notificationApi, state: 'update' },
      onSuccess: (json) => {
        setSlot({ ...slot, ...json })
        setLoading(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  const back = () => {
    if (from === 'list') {
      navigate(`/admin/slots_dashboard?day=${dayjs(slot.begin_date).format('YYYY-MM-DD')}`)
    } else if (from === 'calendar') {
      navigate(`/admin/boxes/${slot.box.id}/calendar?day=${dayjs(slot.begin_date).format('YYYY-MM-DD')}`)
    } else if (from === 'chat') {
      navigate('/admin/chats')
    } else {
      navigate('/admin/events')
    }
  }

  return (
    <>
      {!screens.lg && slot && <AdminSlotCard form={form} slot={slot} setSlot={setSlot} loading={loading} setLoading={setLoading} cancel={cancel} back={back} delay={delay} setIsDirty={setIsDirty} />}
      {screens.lg && slot && <AdminSlotPage form={form} slot={slot} setSlot={setSlot} loading={loading} setLoading={setLoading} cancel={cancel} back={back} delay={delay} setIsDirty={setIsDirty} />}
    </>
  )
}
